import { PLACEHOLDER } from "utils/constants";

export const getWindowSize = () => {
  try {
    return `${window.innerWidth} x ${window.innerHeight}`;
  } catch (e) {
    return PLACEHOLDER;
  }
};

export const getDevicePixelRatio = () => {
  try {
    return `(${window.devicePixelRatio}x)`;
  } catch (e) {
    return "";
  }
};

export const getBrowserMemoryUsage = () => {
  try {
    if (!performance["memory"].usedJSHeapSize) {
      return PLACEHOLDER;
    }
    if (!performance["memory"].jsHeapSizeLimit) {
      if (performance["memory"].usedJSHeapSize) {
        return `${(performance["memory"].usedJSHeapSize / 1048576).toFixed(
          1
        )} MB`;
      }
      return PLACEHOLDER;
    }
    const percentage =
      (performance["memory"].usedJSHeapSize /
        performance["memory"].jsHeapSizeLimit) *
      100;
    return `${(performance["memory"].usedJSHeapSize / 1048576).toFixed(
      1
    )} MB / ${(performance["memory"].jsHeapSizeLimit / 1048576).toFixed(
      0
    )} MB (${percentage.toFixed(1)}%)`;
  } catch (e) {
    return PLACEHOLDER;
  }
};

export const getBrowserMemoryUsageValue = () => {
  try {
    if (!performance["memory"].usedJSHeapSize) {
      return 0;
    }
    return Number((performance["memory"].usedJSHeapSize / 1048576).toFixed(2));
  } catch (e) {
    return 0;
  }
};

export const getBrowserMemorySize = () => {
  try {
    if (!performance["memory"].jsHeapSizeLimit) {
      return 0;
    }
    return Number((performance["memory"].jsHeapSizeLimit / 1048576).toFixed(2));
  } catch (e) {
    return 0;
  }
};
